import React from 'react';

import { Input } from '@flixbus/honeycomb-react';
import { Asterisk } from '../../Asterisk';
import { useVoucherFormContext } from '../../Context';
import { Credit } from '../Credit';

const RideHybrid = () => {
  const {
    formState: {
      payload: { discountType },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  const defaultDiscountType = {
    type: 'free_ride_hybrid',
    quantity: 1,
    credit: 0,
    currency: 'EUR',
  };

  const currentDiscountType =
    discountType?.type === 'free_ride_hybrid' ? discountType : defaultDiscountType;

  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsedValue = parseInt(e.target.value, 10) || 0;

    handlePayloadChange({
      value: {
        ...currentDiscountType,
        quantity: parsedValue,
      },
      prop: 'discountType',
    });
  };

  return (
    <>
      <Input
        name='discount-quantity'
        id='discount-quantity'
        label={
          <>
            Quantity <Asterisk />
          </>
        }
        type='number'
        min='1'
        max='2'
        required
        value={currentDiscountType.quantity}
        onChange={handleQuantityChange}
      />
      <br />
      <Credit />
    </>
  );
};

export default RideHybrid;
